export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11971.eeb84a27.jpg";